import React from 'react';
import { Users } from 'lucide-react';

const UserGrowthChart = ({ userAnalytics = {} }) => {
 // Use available data from backend
 const totalUsers = userAnalytics.total || 0;
 const newUsers = userAnalytics.total || 0;
 const newClients = userAnalytics.new_clients || 0;
 const newVendors = userAnalytics.new_vendors || 0;
 const activeUsers = userAnalytics.active || 0;
 const verifiedUsers = userAnalytics.verified || 0;
 
 // Create simple growth data from available stats
 const growthData = [
 { period: 'Clients', count: newClients },
 { period: 'Vendors', count: newVendors },
 { period: 'Active', count: activeUsers },
 { period: 'Verified', count: verifiedUsers },
 { period: 'Total', count: totalUsers }
 ].filter(item => item.count > 0);

 // Always render the component, even with empty data
 if (growthData.length === 0 && totalUsers === 0) {
 return (
 <div className="product-panel p-4 sm:p-6">
 <h3 className="text-lg font-semibold text-ink mb-4">User Growth</h3>
 <div className="text-center py-12">
 <Users className="w-12 h-12 text-gray-400 mx-auto mb-4" />
 <p className="text-ink-secondary">No growth data available</p>
 </div>
 </div>
 );
 }

 const maxCount = Math.max(...growthData.map(d => Number(d.count || 0)), 1);

 return (
 <div className="product-panel p-4 sm:p-6">
 <div className="mb-4 flex items-center justify-between">
 <h3 className="text-lg font-semibold text-ink">User Growth</h3>
 <Users className="h-5 w-5 text-ink-tertiary" />
 </div>
 <div className="space-y-3 mb-4">
 {growthData.slice(-5).map((item, index) => {
 const count = Number(item.count || 0);
 const percentage = maxCount > 0 ? (count / maxCount) * 100 : 0;
 return (
 <div key={index} className="space-y-1">
 <div className="flex items-center justify-between text-sm">
 <span className="text-ink-secondary font-medium">{item.period}</span>
 <span className="text-ink font-semibold">{count} users</span>
 </div>
 <div className="h-2.5 w-full rounded-full bg-surface-muted">
 <div
 className="h-2.5 rounded-full bg-ink transition-all duration-500"
 style={{ width: `${percentage}%` }}
 />
 </div>
 </div>
 );
 })}
 </div>
 <div className="pt-4 border-t border-border">
 <div className={`grid gap-4 ${(newClients > 0 || newVendors > 0) ? 'grid-cols-2 sm:grid-cols-4' : 'grid-cols-2'}`}>
 <div>
 <p className="text-xs text-ink-secondary mb-1">Total Users</p>
 <p className="text-lg font-bold text-ink">{totalUsers}</p>
 </div>
 <div>
 <p className="text-xs text-ink-secondary mb-1">New This Period</p>
 <p className="text-lg font-bold text-ink">{newUsers}</p>
 </div>
 {newClients > 0 && (
 <div>
 <p className="text-xs text-ink-secondary mb-1">New Clients</p>
 <p className="text-lg font-bold text-ink">{newClients}</p>
 </div>
 )}
 {newVendors > 0 && (
 <div>
 <p className="text-xs text-ink-secondary mb-1">New Vendors</p>
 <p className="text-lg font-bold text-ink">{newVendors}</p>
 </div>
 )}
 </div>
 </div>
 </div>
 );
};

export default UserGrowthChart;
